import vi from '@/locale/translation/vi.json';
import storePersist from '../storePersist';
import { APP_TRANSLATE_KEY, AppLanguages } from '@/config/constants';
import { ReduxTranslateState } from './type';

const LANG_INITIAL_STATE = {
  result: vi,
  langCode: AppLanguages.VI,
  langDirection: 'ltr',
  isLoading: false,
  isSuccess: false,
};

const INITIAL_STATE = storePersist.get(APP_TRANSLATE_KEY)
  ? storePersist.get(APP_TRANSLATE_KEY)
  : LANG_INITIAL_STATE;

const translateReducer = (state = INITIAL_STATE, action) => {
  const { payload = null, langCode, isRtl = false } = action;
  switch (action.type) {
    case ReduxTranslateState.RESET_STATE:
      return INITIAL_STATE;
    case ReduxTranslateState.REQUEST_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case ReduxTranslateState.REQUEST_FAILED:
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
      };

    case ReduxTranslateState.REQUEST_SUCCESS:
      return {
        result: payload,
        langCode: langCode.toLowerCase(),
        langDirection: isRtl ? 'rtl' : 'ltr',
        isLoading: false,
        isSuccess: true,
      };
    default:
      return state;
  }
};

export default translateReducer;
